import React, {useState} from 'react';
import Autocomplete from 'react-autocomplete';
import {useSelector} from "react-redux";

import {service as ContextNodeService} from "../../Services/ContextNodeService";
import {useDebouncedEffect} from "../../Hooks/EffectHooks";
import {ArrayUtils} from "../../Utils/ArrayUtils";
import {StreamBankAutoCompleteItem} from "../Common/StreamBankAutoCompleteItem";


export const SearchBar = props => {
    const context = useSelector(state => state.contextState.context);
    const user = useSelector(state => state.userState.user);
    const editableContextNodeIds = user?.editableContextNodeIds ?? [];

    const [value, setValue] = useState('');
    const [values, setValues] = useState([]);

    useDebouncedEffect(() => {
        performSearch();
    }, [context, value], 250);

    const getPlaceholder = () => {
        if(!context?.parentProgram) {
            return "Programs";
        } else if(!context?.childProgram) {
            return "Sub-Programs";
        } else if(!context?.project) {
            return "Projects";
        } else if(!context?.conservationAction) {
            return "Conservation Actions";
        }

        return "";
    };

    const performSearch = () => {
        ContextNodeService.GetChildrenContextNodes(context, value)
            .then((x) => {
                const contextNodes = ArrayUtils.SortByMultipleCriteria(x.result, [
                    (a, b) => editableContextNodeIds.includes(b.contextNodeId) - editableContextNodeIds.includes(a.contextNodeId),
                    (a, b) => a.depth - b.depth,
                ]);
                
                setValues(contextNodes);
            });
    };

    const getNodeName = (depth) => {
        if(depth) {
            switch(depth) {
                case 1:
                case 2:
                    return "Program";
                case 3:
                    return "Project";
                case 4:
                    return "Conservation Action";
            }
        }

        return "";
    };

    const { OnUpdate } = props;
    const placeholder = getPlaceholder();

    //If we're not able to search for anything lets hide this.
    if(placeholder === "") {
        return null;
    }

    return <Autocomplete
        value={value}
        inputProps={{ className: 'autocomplete-input', placeholder: placeholder,
            onFocus: (event) => { event.target.setSelectionRange(0, -1); }
        }}
        wrapperStyle={{ position: 'relative', display: 'inline-block' }}
        items={values}
        getItemValue={(item) => item.contextPath}
        onChange={(event, value) => setValue(value)}
        onSelect={(value, item) => {
            setValue('');
            OnUpdate?.(item);
        }}
        renderMenu={children => (
            <div className="sb-autocomplete-menu">
                {
                    children?.length ?
                        children:
                        (
                            value != "" ?
                                <div className="sb-autocomplete-no-items">
                                    No matching results
                                </div>:
                                <div />
                        )
                }
            </div>
        )}
        renderItem={(item, isHighlighted) => (
            <StreamBankAutoCompleteItem
                key={item.contextNodeId}
                isHighlighted={isHighlighted}
                title={item?.title}
                subtitle={getNodeName(item?.depth || 0)}
            />
        )}
    />;
};


